import {
  AUTOCOMPLETE_SEARCH_REQUEST,
  AUTOCOMPLETE_SEARCH_SUCCESS,
  CLEAR_AUTOCOMPLETE_OPTIONS,
  AUTOCOMPLETE_CART_PRODUCTS_REQUEST,
  AUTOCOMPLETE_CART_PRODUCTS_SUCCESS,
  DOWNLOAD_PRICES_LIST,
  SET_SHOW_PRICES_LIST_MODAL,
  DOWNLOAD_PRICES_LIST_SUCCESS,
  DOWNLOAD_PRICES_LIST_ERROR,
  SET_SELECTED_CATALOG_LINE,
  SET_SHOW_SIDE_PANEL,
  SET_SHOW_QUICK_CART,
  SET_SHOW_ESTIMATE,
  GET_BRANDS_BY_SEGMENTS,
  GET_PRODUCTS_BY_LINEA_CATALOGO,
  SEARCH_CATALOG_PRODUCTS,
  SHOW_ITEM_DETAIL,
  HIDE_ITEM_DETAIL,
  SET_CATALOG_SEGMENT,
  SET_FILTER_SELECTED,
  GET_LINEAS_CATALOGOS,
  GET_LINEAS_CATALOGOS_SUCCESS,
  GET_ONLINE_ORDER_TO_MERGE,
  GET_ONLINE_ORDER_TO_MERGE_SUCCESS,
  GET_ONLINE_QUOTATION_TO_MERGE,
  GET_ONLINE_QUOTATION_TO_MERGE_SUCCESS,
  CLEAR_SEARCH_PRODUCT,
  GET_NEWS_FOR_FAVORITES,
  GET_NEWS_FOR_FAVORITES_SUCCESS,
  SET_FILTER_BY_STOCK,
  SET_SELECTED_BRAND,
  TOGGLE_SHOW_BADGE,
  TOGGLE_SHOW_PRICES,
  SAVE_CATALOG_CONFIG,
  SAVE_CATALOG_CONFIG_SUCCESS,
  SAVE_CATALOG_CONFIG_ERROR,
  GET_CATALOG_CONFIG,
  GET_CATALOG_CONFIG_SUCCESS,
  GET_CATALOG_CONFIG_ERROR,
} from '../constants/ActionsTypes'

export const downloadPricesList = (filter, format) => {
  return {
    type: DOWNLOAD_PRICES_LIST,
    payload: { filter, format },
  }
}

export const setFilterByStock = (filterByStock) => ({
  type: SET_FILTER_BY_STOCK,
  payload: filterByStock,
})

export const setShowPricesListModal = () => {
  return {
    type: SET_SHOW_PRICES_LIST_MODAL,
  }
}

export const downloadPricesListSuccess = () => {
  return {
    type: DOWNLOAD_PRICES_LIST_SUCCESS,
  }
}

export const downloadPricesListError = (response) => {
  return {
    type: DOWNLOAD_PRICES_LIST_ERROR,
    payload: response,
  }
}

export const setShowSidePanel = (payload) => {
  return {
    type: SET_SHOW_SIDE_PANEL,
    payload,
  }
}

export const setSelectedCatalogLine = (data) => {
  return {
    type: SET_SELECTED_CATALOG_LINE,
    payload: data,
  }
}

export const setSelectedBrand = (data) => {
  return {
    type: SET_SELECTED_BRAND,
    payload: data,
  }
}

export const setShowQuickCart = (data) => {
  return {
    type: SET_SHOW_QUICK_CART,
    payload: data,
  }
}

export const setShowEstimate = (data) => {
  return {
    type: SET_SHOW_ESTIMATE,
    payload: data,
  }
}

export const getBrandsBySegments = (segmentIds) => {
  return {
    type: GET_BRANDS_BY_SEGMENTS,
    payload: { segmentIds },
  }
}

export const getProductsByLineaCatalogo = (data) => {
  return {
    type: GET_PRODUCTS_BY_LINEA_CATALOGO,
    payload: { ...data },
  }
}

export const searchCatalogProducts = (data) => {
  return {
    type: SEARCH_CATALOG_PRODUCTS,
    payload: {
      ...data,
    },
  }
}

export const showItemDetail = (data) => {
  return {
    type: SHOW_ITEM_DETAIL,
    payload: data,
  }
}

export const hideItemDetail = (data) => {
  return {
    type: HIDE_ITEM_DETAIL,
  }
}

export const setCatalogSegment = (segment) => {
  return {
    type: SET_CATALOG_SEGMENT,
    payload: segment,
  }
}

export const setFilterSelected = (filter) => {
  return {
    type: SET_FILTER_SELECTED,
    payload: filter,
  }
}

export const getLineasCatalogos = () => {
  return {
    type: GET_LINEAS_CATALOGOS,
  }
}

export const getLineasCatalogosSuccess = (lineas) => {
  return {
    type: GET_LINEAS_CATALOGOS_SUCCESS,
    payload: lineas,
  }
}

export const getOnlineOrderToMerge = (id) => {
  return {
    type: GET_ONLINE_ORDER_TO_MERGE,
    payload: id,
  }
}

export const getOnlineOrderToMergeSuccess = (order) => {
  return {
    type: GET_ONLINE_ORDER_TO_MERGE_SUCCESS,
    payload: order,
  }
}

export const getOnlineQuotationToMerge = (id) => {
  return {
    type: GET_ONLINE_QUOTATION_TO_MERGE,
    payload: id,
  }
}

export const getOnlineQuotationToMergeSuccess = (quotation) => {
  return {
    type: GET_ONLINE_QUOTATION_TO_MERGE_SUCCESS,
    payload: quotation,
  }
}

export const clearSearchProduct = () => {
  return {
    type: CLEAR_SEARCH_PRODUCT,
  }
}

export const getNewsForFavorites = (params) => {
  return {
    type: GET_NEWS_FOR_FAVORITES,
    payload: params,
  }
}

export const getNewsForFavoritesSuccess = (data) => {
  return {
    type: GET_NEWS_FOR_FAVORITES_SUCCESS,
    payload: data,
  }
}

export const autocompleteSearchRequest = (query) => ({
  type: AUTOCOMPLETE_SEARCH_REQUEST,
  payload: query,
})

export const autocompleteSearchSuccess = (options) => ({
  type: AUTOCOMPLETE_SEARCH_SUCCESS,
  payload: options,
})

export const clearAutocompleteOptions = () => ({
  type: CLEAR_AUTOCOMPLETE_OPTIONS,
})

export const autocompleteCartProductsRequest = (query) => ({
  type: AUTOCOMPLETE_CART_PRODUCTS_REQUEST,
  payload: query,
})

export const autocompleteCartProductsSuccess = (options) => ({
  type: AUTOCOMPLETE_CART_PRODUCTS_SUCCESS,
  payload: options,
})

export const toggleShowBadge = () => {
  return {
    type: TOGGLE_SHOW_BADGE,
  }
}

export const toggleShowPrices = () => {
  return {
    type: TOGGLE_SHOW_PRICES,
  }
}

export const saveCatalogConfig = (config) => ({
  type: SAVE_CATALOG_CONFIG,
  payload: config,
})

export const saveCatalogConfigSuccess = (response) => ({
  type: SAVE_CATALOG_CONFIG_SUCCESS,
  payload: response,
})

export const saveCatalogConfigError = (error) => ({
  type: SAVE_CATALOG_CONFIG_ERROR,
  payload: error,
})

export const getCatalogConfig = (params) => ({
  type: GET_CATALOG_CONFIG,
  payload: params,
})

export const getCatalogConfigSuccess = (response) => ({
  type: GET_CATALOG_CONFIG_SUCCESS,
  payload: response,
})

export const getCatalogConfigError = (error) => ({
  type: GET_CATALOG_CONFIG_ERROR,
  payload: error,
})
